import { FrequentPassageRequest } from '@legacy-types';

import { api } from '@shared/api/api';

export const approveFrequentPassageRequest = api.createTrigger<FrequentPassageRequest>(
  'frequent-passage-requests/:id/approve'
);
